/* NC Teppich nach Maß – Ergänzungen zu nc-tnm.js
   1. Konfigurator zeigt nur Farben, für die eine Felltextur (custom.fell_textur) hinterlegt ist
   2. Farbtreue: hellere, neutralere Wiedergabe (Weißtöne wirken nicht mehr grau/gelb)
   3. Lebendiges Fell: sanfte Wellenbewegung im Flor, wanderndes Licht */
(function () {
  'use strict';
  if (window.__ncTnmFx) return;
  window.__ncTnmFx = true;

  var EXPOSURE = window.NC_TNM_FX_EXPOSURE || 1.55;
  var AMP = { langhaar: 0.012, kurzhaar: 0.004, tibet: 0.008 };   // Wellen-Amplitude in UV (1 UV = 0,5 m)
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) Farben ohne Textur ausblenden – läuft vor nc-tnm.js (Skript steht weiter oben im Dokument) */
  function filterConfig() {
    var els = document.querySelectorAll('[data-tnm-root] [data-tnm-config]:not([data-fx])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-fx', '');
      try {
        var c = JSON.parse(el.textContent), changed = false;
        c.types.forEach(function (t) {
          var keep = t.variants.filter(function (v) { return !!v.tex; });
          if (keep.length && keep.length < t.variants.length) { t.variants = keep; changed = true; }
        });
        if (changed) el.textContent = JSON.stringify(c);
        var root = el.closest('[data-tnm-root]');
        c.types.forEach(function (t) {
          var cnt = root && root.querySelector('[data-tnm-type="' + t.key + '"] .tnm-type__count');
          if (cnt) cnt.textContent = t.variants.length + ' färger';
        });
      } catch (e) { /* Konfiguration unverändert lassen */ }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', filterConfig); else filterConfig();
  document.addEventListener('shopify:section:load', filterConfig);

  /* 2) Weißtöne: sehr helle, fast neutrale Texturen behutsam aufhellen und neutralisieren */
  function whiten(canvas) {
    if (!canvas || canvas.__fx || !canvas.getContext) return false;
    canvas.__fx = true;
    try {
      var g = canvas.getContext('2d'), n = canvas.width, id = g.getImageData(0, 0, n, canvas.height), d = id.data, m = [0, 0, 0], cnt = 0;
      for (var i = 0; i < d.length; i += 64) { m[0] += d[i]; m[1] += d[i + 1]; m[2] += d[i + 2]; cnt++; }
      m = m.map(function (v) { return v / cnt; });
      var L = 0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2];
      if (L < 200 || Math.max(m[0], m[1], m[2]) - Math.min(m[0], m[1], m[2]) > 30) return false;
      var k = m.map(function (v) { return (v + (238 - v) * 0.6) / v; });
      for (var j = 0; j < d.length; j += 4) {
        for (var c = 0; c < 3; c++) { var x = d[j + c] * k[c]; d[j + c] = x > 255 ? 255 : x; }
      }
      g.putImageData(id, 0, 0);
      return true;
    } catch (e) { return false; }
  }

  /* 3) Szene erweitern, sobald der 3D-Teppich existiert */
  var uTime = { value: 0 };
  function onBC(shader) {
    var u = this.userData.fx;
    shader.uniforms.uTime = uTime; shader.uniforms.uT = u.t; shader.uniforms.uAmp = u.a;
    shader.fragmentShader = 'uniform float uTime;\nuniform float uT;\nuniform float uAmp;\n' + shader.fragmentShader.replace('#include <alphamap_fragment>',
      '#ifdef USE_ALPHAMAP\n' +
      '  vec2 fxUv = vAlphaMapUv + uAmp * uT * uT * vec2(sin(vAlphaMapUv.x * 5.0 + vAlphaMapUv.y * 3.0 - uTime * 1.4), 0.6 * cos(vAlphaMapUv.y * 4.0 - vAlphaMapUv.x * 2.0 - uTime * 1.1));\n' +
      '  diffuseColor.a *= texture2D( alphaMap, fxUv ).g;\n' +
      '#endif');
  }
  function fxShells(S) {
    if (reduce) return;
    var a = AMP[S.state && S.state.type] || AMP.langhaar;
    (S.shells || []).forEach(function (sh) {
      var m = sh.material;
      if (!m.userData.fx) { m.userData.fx = { t: { value: 0 }, a: { value: 0 } }; m.onBeforeCompile = onBC; m.needsUpdate = true; }
      m.userData.fx.t.value = sh.userData.t; m.userData.fx.a.value = a;
    });
  }
  function fxTexture(S) {
    if (S._tex && S._tex !== S.__fxTex) {
      S.__fxTex = S._tex;
      if (whiten(S._tex.image)) S._tex.needsUpdate = true;
    }
  }

  function enhance(S) {
    var T = S.T;
    S.renderer.toneMapping = T.ACESFilmicToneMapping;
    S.renderer.toneMappingExposure = EXPOSURE;
    S.scene.traverse(function (o) {
      if (o.isHemisphereLight) { o.color.set(0xffffff); o.groundColor.set(0xe6e0d8); }
    });
    if (S.sun) S.sun.color.set(0xfffaf3);

    var up = S.update;
    S.update = function (st) { up.call(this, st); fxShells(this); fxTexture(this); };
    var ar = S.applyRepeat;
    S.applyRepeat = function () { fxTexture(this); return ar.apply(this, arguments); };

    if (!reduce) {
      S.loop = function () {
        if (this._raf) return;
        var self = this;
        var tick = function (now) {
          self._raf = null;
          if (!self.visible) return;
          var o = self.orbit, g = self.goal;
          if (self.autoRotate) g.theta += 0.0022;
          ['theta', 'phi', 'radius'].forEach(function (key) {
            var d = g[key] - o[key];
            if (Math.abs(d) > 0.0005) o[key] += d * 0.12; else o[key] = g[key];
          });
          var sp = Math.sin(o.phi);
          self.camera.position.set(o.target.x + o.radius * sp * Math.sin(o.theta), o.target.y + o.radius * Math.cos(o.phi), o.target.z + o.radius * sp * Math.cos(o.theta));
          self.camera.lookAt(o.target);
          uTime.value = now / 1000;
          self.placeShells(now);
          if (self.sun) { var a = now * 0.00012; self.sun.position.set(-4 + Math.sin(a) * 1.6, 7, 3 + Math.cos(a) * 1.6); }
          self.renderer.render(self.scene, self.camera);
          self.dirty = false;
          self._raf = requestAnimationFrame(tick);
        };
        this._raf = requestAnimationFrame(tick);
      };
      if (S._raf) { cancelAnimationFrame(S._raf); S._raf = null; }
    }
    fxShells(S); fxTexture(S);
    labels(S);
    S.dirty = true; S.loop();
  }

  /* 4) Maße an Teppich und Möbeln – HTML-Etiketten, pro Frame auf die 3D-Position projiziert */
  var FURN_LABELS = {
    sofa: function (l) { var zb = -l / 2 - 0.70; return [['Soffa', '220 × 90 cm', 0, 0.98, zb + 0.35], ['Soffbord', '110 × 60 cm', 0, 0.46, 0]]; },
    bed: function (l) { var zh = -l / 2 - 0.5; return [['Säng', '180 × 200 cm', 0, 0.62, zh + 1.15]]; },
    dining: function () { return [['Matbord', '200 × 100 cm', 0, 0.86, 0]]; }
  };
  function cm(m) { return Math.round(m * 100); }
  function labels(S) {
    var T = S.T, wrap = S.renderer.domElement.parentNode;
    if (!wrap || S.__lab) return;
    var layer = document.createElement('div');
    layer.className = 'tnm-mls';
    layer.setAttribute('aria-hidden', 'true');
    wrap.appendChild(layer);
    if (!document.getElementById('tnm-mls-css')) {
      var css = document.createElement('style'); css.id = 'tnm-mls-css';
      css.textContent = '.tnm-mls{position:absolute;inset:0;pointer-events:none;overflow:hidden;z-index:2}' +
        '.tnm-ml{position:absolute;left:0;top:0;transform:translate(-50%,-100%);white-space:nowrap;display:flex;align-items:baseline;gap:6px;padding:5px 9px 5px 8px;background:rgba(255,255,255,.86);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);border:1px solid rgba(29,26,23,.12);font-size:10.5px;line-height:1;color:#1d1a17;letter-spacing:.04em;transition:opacity .25s ease;will-change:transform}' +
        '.tnm-ml b{font-weight:500;font-size:9px;letter-spacing:.18em;text-transform:uppercase;color:#7a7169}' +
        '.tnm-ml::after{content:"";position:absolute;left:50%;top:100%;width:1px;height:10px;background:rgba(29,26,23,.35)}' +
        '.tnm-ml--rug{background:#1d1a17;color:#fff;border-color:#1d1a17;transform:translate(-50%,0)}' +
        '.tnm-ml--rug b{color:rgba(255,255,255,.65)}.tnm-ml--rug::after{top:auto;bottom:100%}' +
        '.tnm[data-view="plan"] .tnm-mls{display:none}';
      document.head.appendChild(css);
    }
    var items = [], v = new T.Vector3();
    function rebuild(st) {
      layer.innerHTML = ''; items = [];
      if (!st) return;
      var w = st.w || 2, l = st.l || 3;
      var list = (FURN_LABELS[st.room] ? FURN_LABELS[st.room](l) : []).slice();
      list.push(['Din matta', st.shape === 'round' ? 'Ø ' + cm(w) + ' cm' : cm(w) + ' × ' + cm(l) + ' cm', 0, 0.02, st.shape === 'round' ? w / 2 + 0.05 : l / 2 + 0.05, 'rug']);
      list.forEach(function (it) {
        var el = document.createElement('span');
        el.className = 'tnm-ml' + (it[5] ? ' tnm-ml--' + it[5] : '');
        el.innerHTML = '<b>' + it[0] + '</b>' + it[1];
        layer.appendChild(el);
        items.push({ el: el, p: new T.Vector3(it[2], it[3], it[4]) });
      });
    }
    function place() {
      var r = S.renderer.domElement, W = r.clientWidth, H = r.clientHeight;
      for (var i = 0; i < items.length; i++) {
        v.copy(items[i].p).project(S.camera);
        var off = v.z > 1 || v.x < -1.1 || v.x > 1.1 || v.y < -1.1 || v.y > 1.1;
        items[i].el.style.opacity = off ? 0 : 1;
        items[i].el.style.transform = 'translate(' + ((v.x + 1) / 2 * W).toFixed(1) + 'px,' + ((1 - v.y) / 2 * H).toFixed(1) + 'px) ' + (items[i].el.classList.contains('tnm-ml--rug') ? 'translate(-50%,10px)' : 'translate(-50%,calc(-100% - 10px))');
      }
    }
    var up2 = S.update;
    S.update = function (st) { up2.call(this, st); rebuild(st); place(); };
    var rr = S.renderer.render.bind(S.renderer);
    S.renderer.render = function (sc, cam) { rr(sc, cam); if (items.length) place(); };
    S.__lab = true;
    rebuild(S.state); place();
  }

  var timer = setInterval(function () {
    var roots = document.querySelectorAll('[data-tnm-root]');
    for (var i = 0; i < roots.length; i++) {
      var c = roots[i]._tnm, S = c && c.three;
      if (S && !S.__fxOn) { S.__fxOn = true; try { enhance(S); } catch (e) { if (window.console) console.warn('[NC Teppich FX]', e); } }
    }
    if (roots.length && [].every.call(roots, function (r) { return r._tnm && (r._tnm.three ? r._tnm.three.__fxOn : r.classList.contains('no-3d')); })) clearInterval(timer);
  }, 400);
})();
